import React from "react";
import alert from "./alert.png";
import TableData from "./Table/TableData"
export default function Leadtime() {
  return (
    <div>
      <div class="flex flex-wrap justify-center">
          
          <div
            className="tabelcontainer flex-auto mt-8 overflow-auto mx-4"
            // "w-[calc(100vw_-_12rem)]"
          >
          <TableData/>
          {/* <table className="w-full mt-4 text-sm text-left text-gray-500 dark:text-gray-400">
              <thead className="text-xs  uppercase ">
                <tr className="border-b-8 text-white bg-violet-800 border-white ">
                  <th scope="col" className="px-6 py-3">
                    Id
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Item Code
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Item Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Lead Time
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Status
                  </th>
                  <th scope="col" className="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b-8 border-white bg-gray-100 hover:bg-cyan-200 active:bg-cyan-200 hover:cursor-pointer">
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 "
                  >
                    1
                  </th>
                  <td className="px-6 text-gray-900 py-4 font-medium">123-xyz</td>
                  <td className="px-6 text-gray-900 py-4 font-medium">
                    3D Printing
                  </td>
                  <td className="px-6 text-gray-900 py-4 font-medium">
                    <div className="shadow-lg shadow-slate-300 bg-gray-200 w-max p-2 rounded-lg">
                    <div className="svgdiv">
                    <svg
                      width="22"
                      height="19"
                      viewBox="0 0 22 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                        fill="#1F78B4"
                      />
                    </svg>
                  </div>
                  <div className="svgdiv float-right relative top-[-18px] right-[30px]">
                    <svg
                      width="22"
                      height="19"
                      viewBox="0 0 22 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                        fill="#1F78B4"
                      />
                    </svg>
                  </div> 2-Oct-2021 - 21-Oct-2021{" "}
                    </div>
                  </td>

                  <td className="px-6 text-gray-900 py-4 font-medium text-left">
                    Issue{" "}
                    <div class="w-full bg-gray-200 rounded-full h-2.5 ">
                      <div
                        class="bg-blue-600 h-2.5 rounded-full"
                        style={{ width: "45%" }}
                      ></div>
                    </div>
                  </td>
                  <td>
                    <img src={alert} className="w-5" />
                  </td>
                </tr>
                <tr className="border-b-8 border-white bg-gray-100 hover:bg-cyan-200 active:bg-cyan-200 hover:cursor-pointer">
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 "
                  >
                    2
                  </th>
                  <td className="px-6 py-4 font-medium text-gray-900">
                  123-xyz
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900">
                    2 X 4 m staging platform
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900">
                    <div className="shadow-lg shadow-slate-300 bg-gray-200 w-max p-2 rounded-lg">
                      {" "}
                      2-Oct-2021 - 21-Oct-2021{" "}
                    </div>
                  </td>
                  <td className="px-6 font-medium text-gray-900 py-4 text-left">
                    Issue
                  </td>
                  <td>
                  <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.0001 14.0833L15.5435 17.9267C15.9498 18.2084 16.501 18.1509 16.8404 17.7914L27.5001 6.5" stroke="#06E07F" stroke-width="2" stroke-linecap="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.596 13.4161L19.4771 7.18648C19.8563 6.78488 19.8381 6.15198 19.4365 5.77285C19.0349 5.39372 18.402 5.41193 18.0228 5.81353L11.9606 12.235L13.596 13.4161ZM10.1339 17.0834L8.49853 15.9022L7.34552 17.1236L3.04498 14.3282C2.58192 14.0272 1.96254 14.1586 1.66155 14.6217C1.36056 15.0847 1.49195 15.7041 1.95501 16.0051L6.25555 18.8005C7.06571 19.3271 8.13651 19.1992 8.79983 18.4965L10.1339 17.0834Z" fill="#06E07F"/>
                  </svg>
                  </td>
                </tr>
                <tr className=" border-b-8 border-white bg-gray-100 hover:bg-cyan-200 active:bg-cyan-200 hover:cursor-pointer ">
                  <th
                    scope="row"
                    className="px-6 py-4 font-medium text-gray-900 "
                  >
                    3
                  </th>
                  <td className="px-6 py-4 font-medium text-gray-900">
                  123-xyz
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900">
                    2 X 4 m staging platform
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900">
                    <div className="shadow-lg shadow-slate-300 bg-gray-200 w-max p-2 rounded-lg">
                      {" "}
                      2-Oct-2021 - 21-Oct-2021{" "}
                    </div>
                  </td>
                  <td className="px-6 text-gray-900 font-medium py-4 text-left">
                    Issue
                  </td>
                  <td>
                    <svg
                      width="30"
                      height="26"
                      viewBox="0 0 30 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.1465 0L27.9661 19.5H2.32695L15.1465 0Z"
                        fill="#1F78B4"
                      />
                      <path
                        d="M16.2471 7.35L16.0071 14.595H14.2371L13.9821 7.35H16.2471ZM15.1671 18.105C14.7871 18.105 14.4721 17.99 14.2221 17.76C13.9821 17.52 13.8621 17.225 13.8621 16.875C13.8621 16.525 13.9821 16.235 14.2221 16.005C14.4721 15.765 14.7871 15.645 15.1671 15.645C15.5371 15.645 15.8421 15.765 16.0821 16.005C16.3221 16.235 16.4421 16.525 16.4421 16.875C16.4421 17.225 16.3221 17.52 16.0821 17.76C15.8421 17.99 15.5371 18.105 15.1671 18.105Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                </tr>
              </tbody>
            </table>*/}
          </div>
     
      </div>
    </div>
  );
}
